import { DomainBase } from "./DomainBase";

export class CouponCodeClass extends DomainBase{
    constructor() {
        super();
        this.code = "";
        this.couponName = "";
        this.discountPercent = 0;
    }
}